export enum UploadStatus {
    Ready = 'Ready',
    Requested = 'Requested',
    Started = 'Started',
    Failed = 'Failed',
    Completed = 'Completed'
  }
  
  export interface FileUploadState {
    status: UploadStatus;
    error: string | null;
    progress: number | null;
  }
  
  export const uploadFileInitialState: FileUploadState = {
    status: UploadStatus.Ready,
    error: null,
    progress: null
  };